let timer;

export function debounce(fn: void, ...args) {
  if (timer) {
    clearTimeout(timer);
  }
  const context = this;
  timer = setTimeout(() => {
    fn.apply(context, args);
  }, 300);
}